const iso = (value) => typeof value === 'string' && !Number.isNaN(Date.parse(value));
export function isRoleCatalogItem(value) {
    if (!value || typeof value !== 'object')
        return false;
    const r = value;
    return (typeof r.id === 'string' &&
        typeof r.code === 'string' &&
        typeof r.name === 'string' &&
        typeof r.description === 'string' &&
        typeof r.isSystem === 'boolean' &&
        typeof r.isActive === 'boolean' &&
        Number.isInteger(r.version) &&
        (r.version ?? 0) > 0 &&
        Number.isInteger(r.userCount) &&
        Number.isInteger(r.permissionCount) &&
        iso(r.createdAt) &&
        iso(r.updatedAt));
}
export function isRoleCatalogListResponse(value) {
    if (!value || typeof value !== 'object')
        return false;
    const r = value;
    return (Array.isArray(r.items) &&
        r.items.every(isRoleCatalogItem) &&
        Number.isInteger(r.page) &&
        Number.isInteger(r.pageSize) &&
        Number.isInteger(r.total) &&
        Number.isInteger(r.totalPages));
}
export function isRoleCatalogDetailResponse(value) {
    return Boolean(value &&
        typeof value === 'object' &&
        isRoleCatalogItem(value.role));
}
